import { defineMutator } from "@rocicorp/zero";
import { z } from "zod";

/**
 * Set (upsert) one of the caller's UI flags. Auth (Pattern 1): `ctx.sub` must
 * match `user_id` — the sole write-auth layer. Upsert because setting a flag
 * is idempotent and scoped per-(user, flag), so a dismissal on one device
 * never clobbers a different flag set on another.
 */
export const uiFlagsMutators = {
  set: defineMutator(
    z.object({
      user_id: z.string(),
      flag_key: z.string(),
      value: z
        .union([
          z.boolean(),
          z.number(),
          z.string(),
          z.array(z.string()),
          z.null(),
        ])
        .optional(),
      set_at: z.number(),
    }),
    async ({ tx, args, ctx }) => {
      if (ctx?.sub && args.user_id !== ctx.sub) {
        throw new Error("Unauthorized: user_id mismatch");
      }
      await tx.mutate.user_ui_flags.upsert({
        user_id: args.user_id,
        flag_key: args.flag_key,
        value: args.value ?? null,
        set_at: args.set_at,
      });
    },
  ),
};
